// UI features hidden until they work end-to-end (doc/PRD-12-UI-Cleanup-Hidden-Features.md §5).
// Every key here must have a row in that register; features.test.js enforces it.
// Preview a hidden feature without a code change: REACT_APP_ENABLE_FEATURES=SV_COMPARE,PAGE_PROGRESS
// REACT_APP_ENABLE_FEATURES=* enables every flag, but only on the dev server (ignored in production builds).
export const FEATURES = {
  PAGE_PROGRESS: { enabled: false },
  PAGE_REPORTS: { enabled: false },
  PAGE_SURVEY: { enabled: false },
  PAGE_AERIAL_DATA: { enabled: false },
  HEADER_LIVE_BADGE: { enabled: false },
  PROJECT_CARD_MENU: { enabled: false },
  SV_LAYER_BOUNDARY: { enabled: false },
  SV_LAYER_GRID: { enabled: false },
  SV_LAYER_ANNOTATIONS: { enabled: false },
  SV_COMPARE: { enabled: false },
  SV_DOWNLOAD: { enabled: false },
  SV_SCALE_BAR: { enabled: false },
  SV_LOCATE_BUTTON: { enabled: false },
  SV_WEATHER_ICON: { enabled: false },
  WALKTHROUGH_COMPASS: { enabled: false },
  WALKTHROUGH_SETTINGS: { enabled: false },
  VIEWER3D_LAYER_ANNOTATIONS: { enabled: false },
  VIEWER3D_LAYER_MEASUREMENTS: { enabled: false },
  EARTHWORK_EXPORT: { enabled: false },
  EARTHWORK_ROW_MENU: { enabled: false },
  STOCKPILES_FILTERS: { enabled: false },
  STOCKPILES_EXPORT: { enabled: false },
  STOCKPILES_ROW_MENU: { enabled: false },
  STOCKPILES_REPORT: { enabled: false },
  STOCKPILES_STAGING_INFO: { enabled: false },
};

const overrides = new Set(
  (process.env.REACT_APP_ENABLE_FEATURES || '')
    .split(',')
    .map((k) => k.trim())
    .filter(Boolean)
);
const enableAll = overrides.has('*') && process.env.NODE_ENV !== 'production';

export function isFeatureEnabled(key) {
  const feature = FEATURES[key];
  if (!feature) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Unknown feature flag: ${key}`);
    }
    return false;
  }
  return feature.enabled || enableAll || overrides.has(key);
}

export function Feature({ name, children, fallback = null }) {
  return isFeatureEnabled(name) ? children : fallback;
}
